import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import {AppUtilityService} from "../services/AppUtilityService";

@Injectable()
export class LoginCheck implements CanActivate {
  constructor(private apUtil: AppUtilityService, private router:Router) {};

  // canActivate() {
  //   return this.apUtil.persistenceService().get('clientDetails') !== undefined;
  // }

  canActivate(route: ActivatedRouteSnapshot, ): boolean {
    const requiredRoles = route.data['roles'];
    if(requiredRoles){
      const user = this.apUtil.persistenceService().get('clientDetails');
  
      if (user !== undefined && requiredRoles.includes(user.role)) {
        return true;
      }
    
      this.router.navigate(['/unauthorized']);
      return false;
    }else{
      return this.apUtil.persistenceService().get('clientDetails') !== undefined;
    }
    
  }
}
